"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withdrawBluefinFungibleTxb = exports.withdrawBluefinStsuiTxb = exports.withdrawBluefinType2Txb = exports.withdrawBluefinType1Txb = exports.withdrawBluefinSuiSecondTxb = exports.withdrawBluefinSuiFirstTxb = exports.depositBluefinFungibleTxb = exports.getCoinObject = exports.depositBluefinStsuiTxb = exports.depositBluefinType2Txb = exports.depositBluefinType1Txb = exports.depositBluefinSuiSecondTxb = exports.depositBluefinSuiFirstTxb = void 0;
const transactions_1 = require("@mysten/sui/transactions");
const coins_js_1 = require("../common/coins.js");
const constants_js_1 = require("../common/constants.js");
const maps_js_1 = require("../common/maps.js");
const getReceipts_js_1 = require("../sui-sdk/functions/getReceipts.js");
const client_js_1 = require("../sui-sdk/client.js");
const deposit_js_1 = require("./deposit.js");
const blueRewards_js_1 = require("./blueRewards.js");
const index_js_1 = require("../index.js");
const alphalend_js_1 = require("./alphalend.js");
const stsui_sdk_1 = require("@alphafi/stsui-sdk");
const depositBluefinSuiFirstTxb = async (amount, poolName, isAmountA, options, transaction = undefined) => {
    const suiClient = (0, client_js_1.getSuiClient)();
    const address = options.address;
    let txb;
    if (transaction)
        txb = transaction;
    else
        txb = new transactions_1.Transaction();
    poolName = poolName.toUpperCase();
    const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const receipt = await (0, getReceipts_js_1.getReceipts)(poolName, address, true);
    let coins1 = [];
    let currentCursor = null;
    do {
        const response = await suiClient.getCoins({
            owner: address,
            coinType: coins_js_1.coinsList[pool2].type,
            cursor: currentCursor,
        });
        coins1 = coins1.concat(response.data);
        // Check if there's a next page
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            // No more pages available
            // console.log("No more receipts available.");
            break;
        }
    } while (true);
    const amounts = await (0, deposit_js_1.getAmounts)(poolName, isAmountA, amount);
    if (amounts) {
        const amount1 = amounts[0];
        const amount2 = amounts[1];
        let coin1;
        if (coins1.length >= 1) {
            //coin1
            [coin1] = txb.splitCoins(txb.object(coins1[0].coinObjectId), [0]);
            txb.mergeCoins(coin1, coins1.map((c) => c.coinObjectId));
            const [depositCoinB] = txb.splitCoins(coin1, [amount2]);
            //coin2
            const [depositCoinA] = txb.splitCoins(txb.gas, [amount1]);
            const poolinfo = maps_js_1.poolInfo[poolName];
            let someReceipt;
            if (receipt.length == 0) {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::none`,
                    typeArguments: [poolinfo.receiptType],
                    arguments: [],
                });
            }
            else {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::some`,
                    typeArguments: [receipt[0].content.type],
                    arguments: [txb.object(receipt[0].objectId)],
                });
            }
            if (poolinfo.strategyType === "AUTOBALANCE-LIQUIDITY-POOL") {
                await (0, blueRewards_js_1.collectRewardTxb)(poolName, true, txb);
            }
            if (poolName === "BLUEFIN-SUI-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_first_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUI_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-SUI-BUCK") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_first_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUI_BUCK_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["BUCK-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-SUI-AUSD") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_first_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUI_AUSD_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["AUSD-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (maps_js_1.AUTOBALANCE_SUI_FIRST_POOLS.includes(poolName)) {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_first_pool::user_deposit_v4`,
                    typeArguments: [coins_js_1.coinsList[pool1].type, coins_js_1.coinsList[pool2].type],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(poolinfo.parentPoolId),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            txb.transferObjects([coin1], address);
        }
        else {
            throw new Error(`No ${pool1} or ${pool2} Coins`);
        }
    }
    return txb;
};
exports.depositBluefinSuiFirstTxb = depositBluefinSuiFirstTxb;
const depositBluefinSuiSecondTxb = async (amount, poolName, isAmountA, options, transaction = undefined) => {
    const suiClient = (0, client_js_1.getSuiClient)();
    const address = options.address;
    let txb;
    if (transaction)
        txb = transaction;
    else
        txb = new transactions_1.Transaction();
    poolName = poolName.toUpperCase();
    const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const receipt = await (0, getReceipts_js_1.getReceipts)(poolName, address, true);
    let coins1 = [];
    let currentCursor = null;
    do {
        const response = await suiClient.getCoins({
            owner: address,
            coinType: coins_js_1.coinsList[pool1].type,
            cursor: currentCursor,
        });
        coins1 = coins1.concat(response.data);
        // Check if there's a next page
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            // No more pages available
            // console.log("No more receipts available.");
            break;
        }
    } while (true);
    const amounts = await (0, deposit_js_1.getAmounts)(poolName, isAmountA, amount);
    if (amounts) {
        const amount1 = amounts[0];
        const amount2 = amounts[1];
        let coin1;
        if (coins1.length >= 1) {
            //coin1
            [coin1] = txb.splitCoins(txb.object(coins1[0].coinObjectId), [0]);
            txb.mergeCoins(coin1, coins1.map((c) => c.coinObjectId));
            const [depositCoinA] = txb.splitCoins(coin1, [amount1]);
            //coin2
            const [depositCoinB] = txb.splitCoins(txb.gas, [amount2]);
            const poolinfo = maps_js_1.poolInfo[poolName];
            let someReceipt;
            if (receipt.length == 0) {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::none`,
                    typeArguments: [poolinfo.receiptType],
                    arguments: [],
                });
            }
            else {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::some`,
                    typeArguments: [receipt[0].content.type],
                    arguments: [txb.object(receipt[0].objectId)],
                });
            }
            if (poolinfo.strategyType === "AUTOBALANCE-LIQUIDITY-POOL") {
                await (0, blueRewards_js_1.collectRewardTxb)(poolName, true, txb);
            }
            if (poolName === "BLUEFIN-BLUE-SUI") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_second_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["DEEP"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["BLUE-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-WBTC-SUI") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_second_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_WBTC_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["WBTC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-DEEP-SUI") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_second_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["DEEP-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-STSUI-SUI") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_stsui_sui_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(poolinfo.parentPoolId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (maps_js_1.AUTOBALANCE_SUI_SECOND_POOLS.includes(poolName)) {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_second_pool::user_deposit_v3`,
                    typeArguments: [coins_js_1.coinsList[pool1].type, coins_js_1.coinsList[pool2].type],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(poolinfo.parentPoolId),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolinfo.strategyType === "LEVERAGE-YIELD-FARMING") {
                const coinAType = pool1 === "SUI" ? "0x2::sui::SUI" : coins_js_1.coinsList[pool1].type;
                const coinBType = pool2 === "SUI" ? "0x2::sui::SUI" : coins_js_1.coinsList[pool2].type;
                await alphalend_js_1.alphalendClient.updatePrices(txb, [coinAType, coinBType]);
                console.log(alphalend_js_1.alphalendClient.constants.ALPHAFI_LATEST_ORACLE_PACKAGE_ID, alphalend_js_1.alphalendClient.constants.ALPHAFI_ORACLE_OBJECT_ID, alphalend_js_1.alphalendClient.constants.ALPHALEND_LATEST_PACKAGE_ID, alphalend_js_1.alphalendClient.constants.LENDING_PROTOCOL_ID);
                await (0, index_js_1.collectAndSwapRewardsLyf)(poolName, txb);
                console.log(amount1, amount2);
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_lyf_pool::user_deposit`,
                    typeArguments: [coins_js_1.coinsList[pool1].type, coins_js_1.coinsList[pool2].type],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_LYF_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object((0, constants_js_1.getConf)().LENDING_PROTOCOL_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(poolinfo.parentPoolId),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            txb.transferObjects([coin1], address);
        }
        else {
            throw new Error(`No ${pool1} or ${pool2} Coins`);
        }
    }
    return txb;
};
exports.depositBluefinSuiSecondTxb = depositBluefinSuiSecondTxb;
const depositBluefinType1Txb = async (amount, poolName, isAmountA, options, transaction = undefined) => {
    const suiClient = (0, client_js_1.getSuiClient)();
    const address = options.address;
    let txb;
    if (transaction)
        txb = transaction;
    else
        txb = new transactions_1.Transaction();
    poolName = poolName.toUpperCase();
    const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const receipt = await (0, getReceipts_js_1.getReceipts)(poolName, address, true);
    let coins1 = [];
    let coins2 = [];
    let currentCursor = null;
    do {
        const response = await suiClient.getCoins({
            owner: address,
            coinType: coins_js_1.coinsList[pool1].type,
            cursor: currentCursor,
        });
        coins1 = coins1.concat(response.data);
        // Check if there's a next page
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            // No more pages available
            // console.log("No more receipts available.");
            break;
        }
    } while (true);
    currentCursor = null;
    do {
        const response = await suiClient.getCoins({
            owner: address,
            coinType: coins_js_1.coinsList[pool2].type,
            cursor: currentCursor,
        });
        coins2 = coins2.concat(response.data);
        // Check if there's a next page
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            // No more pages available
            // console.log("No more receipts available.");
            break;
        }
    } while (true);
    const amounts = await (0, deposit_js_1.getAmounts)(poolName, isAmountA, amount);
    if (amounts) {
        const amount1 = amounts[0];
        const amount2 = amounts[1];
        let coin1;
        let coin2;
        if (coins1.length >= 1 && coins2.length >= 1) {
            //coin1
            [coin1] = txb.splitCoins(txb.object(coins1[0].coinObjectId), [0]);
            txb.mergeCoins(coin1, coins1.map((c) => c.coinObjectId));
            const [depositCoinA] = txb.splitCoins(coin1, [amount1]);
            //coin2
            [coin2] = txb.splitCoins(txb.object(coins2[0].coinObjectId), [0]);
            txb.mergeCoins(coin2, coins2.map((c) => c.coinObjectId));
            const [depositCoinB] = txb.splitCoins(coin2, [amount2]);
            const poolinfo = maps_js_1.poolInfo[poolName];
            let someReceipt;
            if (receipt.length == 0) {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::none`,
                    typeArguments: [poolinfo.receiptType],
                    arguments: [],
                });
            }
            else {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::some`,
                    typeArguments: [receipt[0].content.type],
                    arguments: [txb.object(receipt[0].objectId)],
                });
            }
            if (poolinfo.strategyType === "AUTOBALANCE-LIQUIDITY-POOL") {
                await (0, blueRewards_js_1.collectRewardTxb)(poolName, true, txb);
            }
            if (poolName === "BLUEFIN-USDT-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_USDT_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_USDT_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-USDT"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-AUSD-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_AUSD_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_AUSD_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-AUSD"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-WBTC-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_WBTC_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_WBTC_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-WBTC"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-SEND-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SEND_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SEND_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SEND"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-STSUI-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-STSUI"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (maps_js_1.AUTOBALANCE_TYPE_1_POOLS.includes(poolName)) {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_deposit_v3`,
                    typeArguments: [coins_js_1.coinsList[pool1].type, coins_js_1.coinsList[pool2].type],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(poolinfo.parentPoolId),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-SUIUSDT-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUIUSDT_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUIUSDT_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUIUSDT"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-SUIBTC-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                        coins_js_1.coinsList["DEEP"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUIBTC_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                        coins_js_1.coinsList["DEEP"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUIBTC_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUIBTC"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-LBTC-SUIBTC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                        coins_js_1.coinsList["DEEP"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_LBTC_SUIBTC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-SUIBTC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                        coins_js_1.coinsList["DEEP"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_LBTC_SUIBTC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["SUIBTC-LBTC"]),
                        txb.object(maps_js_1.cetusPoolMap["SUIBTC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-WAL-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_WAL_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_WAL_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-WAL"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            txb.transferObjects([coin1], address);
            txb.transferObjects([coin2], address);
        }
        else {
            throw new Error(`No ${pool1} or ${pool2} Coins`);
        }
    }
    return txb;
};
exports.depositBluefinType1Txb = depositBluefinType1Txb;
const depositBluefinType2Txb = async (amount, poolName, isAmountA, options, transaction = undefined) => {
    const suiClient = (0, client_js_1.getSuiClient)();
    const address = options.address;
    let txb;
    if (transaction)
        txb = transaction;
    else
        txb = new transactions_1.Transaction();
    poolName = poolName.toUpperCase();
    const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const receipt = await (0, getReceipts_js_1.getReceipts)(poolName, address, true);
    let coins1 = [];
    let coins2 = [];
    let currentCursor = null;
    do {
        const response = await suiClient.getCoins({
            owner: address,
            coinType: coins_js_1.coinsList[pool1].type,
            cursor: currentCursor,
        });
        coins1 = coins1.concat(response.data);
        // Check if there's a next page
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            // No more pages available
            // console.log("No more receipts available.");
            break;
        }
    } while (true);
    currentCursor = null;
    do {
        const response = await suiClient.getCoins({
            owner: address,
            coinType: coins_js_1.coinsList[pool2].type,
            cursor: currentCursor,
        });
        coins2 = coins2.concat(response.data);
        // Check if there's a next page
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            // No more pages available
            // console.log("No more receipts available.");
            break;
        }
    } while (true);
    const amounts = await (0, deposit_js_1.getAmounts)(poolName, isAmountA, amount);
    if (amounts) {
        const amount1 = amounts[0];
        const amount2 = amounts[1];
        let coin1;
        let coin2;
        if (coins1.length >= 1 && coins2.length >= 1) {
            //coin1
            [coin1] = txb.splitCoins(txb.object(coins1[0].coinObjectId), [0]);
            txb.mergeCoins(coin1, coins1.map((c) => c.coinObjectId));
            const [depositCoinA] = txb.splitCoins(coin1, [amount1]);
            //coin2
            [coin2] = txb.splitCoins(txb.object(coins2[0].coinObjectId), [0]);
            txb.mergeCoins(coin2, coins2.map((c) => c.coinObjectId));
            const [depositCoinB] = txb.splitCoins(coin2, [amount2]);
            const poolinfo = maps_js_1.poolInfo[poolName];
            let someReceipt;
            if (receipt.length == 0) {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::none`,
                    typeArguments: [poolinfo.receiptType],
                    arguments: [],
                });
            }
            else {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::some`,
                    typeArguments: [receipt[0].content.type],
                    arguments: [txb.object(receipt[0].objectId)],
                });
            }
            if (poolName === "BLUEFIN-ALPHA-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_2_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_ALPHA_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["ALPHA-USDC"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-NAVX-VSUI") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_2_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_NAVX_VSUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["NAVX-VSUI"]),
                        txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-BLUE-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_2_pool::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["DEEP"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["BLUE-USDC"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-STSUI-ETH") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_2_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_ETH_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["STSUI-ETH"]),
                        txb.object(maps_js_1.cetusPoolMap["ETH-SUI"]),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-STSUI-WSOL") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_2_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_WSOL_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["STSUI-WSOL"]),
                        txb.object(maps_js_1.cetusPoolMap["WSOL-SUI"]),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            txb.transferObjects([coin1], address);
            txb.transferObjects([coin2], address);
        }
        else {
            throw new Error(`No ${pool1} or ${pool2} Coins`);
        }
    }
    return txb;
};
exports.depositBluefinType2Txb = depositBluefinType2Txb;
const depositBluefinStsuiTxb = async (amount, poolName, isAmountA, options, transaction = undefined) => {
    const suiClient = (0, client_js_1.getSuiClient)();
    const address = options.address;
    let txb;
    if (transaction)
        txb = transaction;
    else
        txb = new transactions_1.Transaction();
    poolName = poolName.toUpperCase();
    const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const receipt = await (0, getReceipts_js_1.getReceipts)(poolName, address, true);
    let coins1 = [];
    let coins2 = [];
    let currentCursor = null;
    do {
        const response = await suiClient.getCoins({
            owner: address,
            coinType: coins_js_1.coinsList[pool1].type,
            cursor: currentCursor,
        });
        coins1 = coins1.concat(response.data);
        // Check if there's a next page
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            // No more pages available
            // console.log("No more receipts available.");
            break;
        }
    } while (true);
    currentCursor = null;
    do {
        const response = await suiClient.getCoins({
            owner: address,
            coinType: coins_js_1.coinsList[pool2].type,
            cursor: currentCursor,
        });
        coins2 = coins2.concat(response.data);
        // Check if there's a next page
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            // No more pages available
            // console.log("No more receipts available.");
            break;
        }
    } while (true);
    const amounts = await (0, deposit_js_1.getAmounts)(poolName, isAmountA, amount);
    console.log(amounts);
    if (amounts) {
        const amount1 = amounts[0];
        const amount2 = amounts[1];
        let coin1;
        let coin2;
        if (coins1.length >= 1 && coins2.length >= 1) {
            //coin1
            [coin1] = txb.splitCoins(txb.object(coins1[0].coinObjectId), [0]);
            txb.mergeCoins(coin1, coins1.map((c) => c.coinObjectId));
            const [depositCoinA] = txb.splitCoins(coin1, [amount1]);
            //coin2
            [coin2] = txb.splitCoins(txb.object(coins2[0].coinObjectId), [0]);
            txb.mergeCoins(coin2, coins2.map((c) => c.coinObjectId));
            const [depositCoinB] = txb.splitCoins(coin2, [amount2]);
            const poolinfo = maps_js_1.poolInfo[poolName];
            let someReceipt;
            if (receipt.length == 0) {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::none`,
                    typeArguments: [poolinfo.receiptType],
                    arguments: [],
                });
            }
            else {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::some`,
                    typeArguments: [receipt[0].content.type],
                    arguments: [txb.object(receipt[0].objectId)],
                });
            }
            if (poolName === "BLUEFIN-STSUI-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_stsui_first_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_USDC_ZERO_ONE_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.pure.bool(true),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-ALPHA-STSUI") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_stsui_second_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_ALPHA_STSUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["ALPHA-SUI"]),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-ALPHA"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.pure.bool(true),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-STSUI-WSOL") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_stsui_first_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_WSOL_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["WSOL-SUI"]),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-WSOL"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.pure.bool(true),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-STSUI-ETH") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_stsui_first_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_ETH_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["ETH-SUI"]),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-ETH"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.pure.bool(true),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-STSUI-BUCK") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_stsui_first_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_BUCK_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["BUCK-SUI"]),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-BUCK"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.pure.bool(true),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-STSUI-MUSD") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_stsui_first_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_MUSD_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["MUSD-SUI"]),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-MUSD"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.pure.bool(true),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-WAL-STSUI") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_stsui_second_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        someReceipt,
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_WAL_STSUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["WAL-SUI"]),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-WAL"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.pure.bool(true),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            txb.transferObjects([coin1], address);
            txb.transferObjects([coin2], address);
        }
        else {
            throw new Error(`No ${pool1} or ${pool2} Coins`);
        }
    }
    return txb;
};
exports.depositBluefinStsuiTxb = depositBluefinStsuiTxb;
const getCoinObject = async (type, address, tx) => {
    let txb;
    if (!tx) {
        txb = new transactions_1.Transaction();
    }
    else {
        txb = tx;
    }
    let coins1 = [];
    let currentCursor = null;
    do {
        const response = await (0, client_js_1.getSuiClient)().getCoins({
            owner: address,
            coinType: type,
            cursor: currentCursor,
        });
        coins1 = coins1.concat(response.data);
        // Check if there's a next page
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            // No more pages available
            // console.log("No more receipts available.");
            break;
        }
    } while (true);
    if (coins1.length >= 1) {
        //coin1
        const [coin1] = txb.splitCoins(coins1[0].coinObjectId, [0]);
        txb.mergeCoins(coin1, coins1.map((c) => c.coinObjectId));
        return coin1;
    }
};
exports.getCoinObject = getCoinObject;
const depositBluefinFungibleTxb = async (amount, poolName, isAmountA, options, transaction = undefined) => {
    const suiClient = (0, client_js_1.getSuiClient)();
    const address = options.address;
    let txb;
    if (transaction)
        txb = transaction;
    else
        txb = new transactions_1.Transaction();
    poolName = poolName.toUpperCase();
    const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    let coins1 = [];
    let currentCursor = null;
    do {
        const response = await suiClient.getCoins({
            owner: address,
            coinType: coins_js_1.coinsList[pool1].type,
            cursor: currentCursor,
        });
        coins1 = coins1.concat(response.data);
        // Check if there's a next page
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            // No more pages available
            // console.log("No more receipts available.");
            break;
        }
    } while (true);
    const amounts = await (0, deposit_js_1.getAmounts)(poolName, isAmountA, amount);
    if (amounts) {
        const amount1 = amounts[0];
        const amount2 = amounts[1];
        let coin1;
        if (coins1.length >= 1) {
            //coin1
            [coin1] = txb.splitCoins(txb.object(coins1[0].coinObjectId), [0]);
            txb.mergeCoins(coin1, coins1.map((c) => c.coinObjectId));
            const [depositCoinA] = txb.splitCoins(coin1, [amount1]);
            //coin2
            const [depositCoinB] = txb.splitCoins(txb.gas, [amount2]);
            const poolinfo = maps_js_1.poolInfo[poolName];
            if (poolName === "BLUEFIN-FUNGIBLE-STSUI-SUI") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_stsui_sui_ft_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        poolinfo.receiptType,
                        coins_js_1.coinsList["BLUE"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_FUNGIBLE_VERSION),
                        txb.object(poolinfo.poolId),
                        depositCoinA,
                        depositCoinB,
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            txb.transferObjects([coin1], address);
        }
        else {
            throw new Error(`No ${pool1} or ${pool2} Coins`);
        }
    }
    return txb;
};
exports.depositBluefinFungibleTxb = depositBluefinFungibleTxb;
const withdrawBluefinSuiFirstTxb = async (xTokens, poolName, options) => {
    const address = options.address;
    let txb = new transactions_1.Transaction();
    const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const receipt = await (0, getReceipts_js_1.getReceipts)(poolName, address, true);
    const alphaReceipt = await (0, getReceipts_js_1.getReceipts)("ALPHA", address, true);
    if (receipt.length > 0) {
        const poolinfo = maps_js_1.poolInfo[poolName];
        if (poolName.toString().includes("AUTOBALANCE")) {
            if (xTokens === receipt[0].content.fields.xTokenBalance) {
                const res = await (0, blueRewards_js_1.claimRewardsTxb)(address, poolName);
                if (res) {
                    txb = res.txb;
                    txb.transferObjects(res.coinOut, address);
                }
            }
            else {
                await (0, blueRewards_js_1.collectRewardTxb)(poolName, true, txb);
            }
            if (maps_js_1.AUTOBALANCE_SUI_FIRST_POOLS.includes(poolName)) {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_first_pool::user_withdraw_v4`,
                    typeArguments: [coins_js_1.coinsList[pool1].type, coins_js_1.coinsList[pool2].type],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                        txb.object(receipt[0].objectId),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(poolinfo.parentPoolId),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
        }
        else {
            let alpha_receipt;
            if (alphaReceipt.length == 0) {
                [alpha_receipt] = txb.moveCall({
                    target: `0x1::option::none`,
                    typeArguments: [(0, constants_js_1.getConf)().ALPHA_POOL_RECEIPT],
                    arguments: [],
                });
            }
            else {
                [alpha_receipt] = txb.moveCall({
                    target: `0x1::option::some`,
                    typeArguments: [alphaReceipt[0].content.type],
                    arguments: [txb.object(alphaReceipt[0].objectId)],
                });
            }
            if (poolName === "BLUEFIN-SUI-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_first_pool::user_withdraw_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUI_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-SUI-BUCK") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_first_pool::user_withdraw_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUI_BUCK_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["BUCK-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-SUI-AUSD") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_first_pool::user_withdraw_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUI_AUSD_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["AUSD-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
        }
    }
    else {
        throw new Error("No receipt found!");
    }
    return txb;
};
exports.withdrawBluefinSuiFirstTxb = withdrawBluefinSuiFirstTxb;
const withdrawBluefinSuiSecondTxb = async (xTokens, poolName, options) => {
    const address = options.address;
    let txb = new transactions_1.Transaction();
    const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const receipt = await (0, getReceipts_js_1.getReceipts)(poolName, address, true);
    const alphaReceipt = await (0, getReceipts_js_1.getReceipts)("ALPHA", address, true);
    if (receipt.length > 0) {
        const poolinfo = maps_js_1.poolInfo[poolName];
        if (poolName.toString().includes("AUTOBALANCE")) {
            if (xTokens === receipt[0].content.fields.xTokenBalance) {
                const res = await (0, blueRewards_js_1.claimRewardsTxb)(address, poolName);
                if (res) {
                    txb = res.txb;
                    txb.transferObjects(res.coinOut, address);
                }
            }
            else {
                await (0, blueRewards_js_1.collectRewardTxb)(poolName, true, txb);
            }
            if (maps_js_1.AUTOBALANCE_SUI_SECOND_POOLS.includes(poolName)) {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_second_pool::user_withdraw_v3`,
                    typeArguments: [coins_js_1.coinsList[pool1].type, coins_js_1.coinsList[pool2].type],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                        txb.object(receipt[0].objectId),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(poolinfo.parentPoolId),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
        }
        else {
            let alpha_receipt;
            if (alphaReceipt.length == 0) {
                [alpha_receipt] = txb.moveCall({
                    target: `0x1::option::none`,
                    typeArguments: [(0, constants_js_1.getConf)().ALPHA_POOL_RECEIPT],
                    arguments: [],
                });
            }
            else {
                [alpha_receipt] = txb.moveCall({
                    target: `0x1::option::some`,
                    typeArguments: [alphaReceipt[0].content.type],
                    arguments: [txb.object(alphaReceipt[0].objectId)],
                });
            }
            if (poolName === "BLUEFIN-BLUE-SUI") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_second_pool::user_withdraw_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["DEEP"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["BLUE-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-WBTC-SUI") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_second_pool::user_withdraw_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_WBTC_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["WBTC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-DEEP-SUI") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_sui_second_pool::user_withdraw_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["DEEP-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-STSUI-SUI") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_stsui_sui_pool::user_withdraw`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(poolinfo.parentPoolId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolinfo.strategyType === "LEVERAGE-YIELD-FARMING") {
                const coinAType = pool1 === "SUI" ? "0x2::sui::SUI" : coins_js_1.coinsList[pool1].type;
                const coinBType = pool2 === "SUI" ? "0x2::sui::SUI" : coins_js_1.coinsList[pool2].type;
                await alphalend_js_1.alphalendClient.updatePrices(txb, [coinAType, coinBType]);
                await (0, index_js_1.collectAndSwapRewardsLyf)(poolName, txb);
                const [lyfReceiptOption, lyfBalanceA, lyfBalanceB] = txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_lyf_pool::withdraw`,
                    typeArguments: [coins_js_1.coinsList[pool1].type, coins_js_1.coinsList[pool2].type],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_LYF_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().LENDING_PROTOCOL_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(poolinfo.parentPoolId),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                if (receipt[0].content.fields.xTokenBalance !== xTokens) {
                    const [lyfReceipt] = txb.moveCall({
                        target: `0x1::option::extract`,
                        typeArguments: [poolinfo.receiptType],
                        arguments: [lyfReceiptOption],
                    });
                    txb.transferObjects([lyfReceipt], address);
                }
                txb.moveCall({
                    target: `0x1::option::destroy_none`,
                    typeArguments: [poolinfo.receiptType],
                    arguments: [lyfReceiptOption],
                });
                const lyfCoinA = txb.moveCall({
                    target: `0x2::coin::from_balance`,
                    typeArguments: [poolinfo.assetTypes[0]],
                    arguments: [lyfBalanceA],
                });
                const lyfCoinB = txb.moveCall({
                    target: `0x2::coin::from_balance`,
                    typeArguments: [poolinfo.assetTypes[1]],
                    arguments: [lyfBalanceB],
                });
                const [sui] = txb.moveCall({
                    target: (0, stsui_sdk_1.getConf)().STSUI_LATEST_PACKAGE_ID + "::liquid_staking::redeem",
                    arguments: [
                        txb.object((0, stsui_sdk_1.getConf)().LST_INFO),
                        lyfCoinA,
                        txb.object((0, stsui_sdk_1.getConf)().SUI_SYSTEM_STATE_OBJECT_ID),
                    ],
                    typeArguments: [(0, stsui_sdk_1.getConf)().STSUI_COIN_TYPE],
                });
                txb.mergeCoins(sui, [lyfCoinB]);
                txb.transferObjects([sui], address);
            }
        }
    }
    else {
        throw new Error("No receipt found!");
    }
    return txb;
};
exports.withdrawBluefinSuiSecondTxb = withdrawBluefinSuiSecondTxb;
const withdrawBluefinType1Txb = async (xTokens, poolName, options) => {
    const address = options.address;
    let txb = new transactions_1.Transaction();
    const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const receipt = await (0, getReceipts_js_1.getReceipts)(poolName, address, true);
    const alphaReceipt = await (0, getReceipts_js_1.getReceipts)("ALPHA", address, true);
    if (receipt.length > 0) {
        const poolinfo = maps_js_1.poolInfo[poolName];
        if (poolName.toString().includes("AUTOBALANCE")) {
            if (xTokens === receipt[0].content.fields.xTokenBalance) {
                const res = await (0, blueRewards_js_1.claimRewardsTxb)(address, poolName);
                if (res) {
                    txb = res.txb;
                    txb.transferObjects(res.coinOut, address);
                }
            }
            else {
                await (0, blueRewards_js_1.collectRewardTxb)(poolName, true, txb);
            }
            if (maps_js_1.AUTOBALANCE_TYPE_1_POOLS.includes(poolName)) {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_withdraw_v3`,
                    typeArguments: [coins_js_1.coinsList[pool1].type, coins_js_1.coinsList[pool2].type],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                        txb.object(receipt[0].objectId),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(poolinfo.parentPoolId),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
        }
        else {
            let alpha_receipt;
            if (alphaReceipt.length == 0) {
                [alpha_receipt] = txb.moveCall({
                    target: `0x1::option::none`,
                    typeArguments: [(0, constants_js_1.getConf)().ALPHA_POOL_RECEIPT],
                    arguments: [],
                });
            }
            else {
                [alpha_receipt] = txb.moveCall({
                    target: `0x1::option::some`,
                    typeArguments: [alphaReceipt[0].content.type],
                    arguments: [txb.object(alphaReceipt[0].objectId)],
                });
            }
            if (poolName === "BLUEFIN-USDT-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_USDT_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_withdraw_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_USDT_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-USDT"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-AUSD-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_AUSD_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_withdraw_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_AUSD_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-AUSD"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-WBTC-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_WBTC_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_withdraw_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_WBTC_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-WBTC"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-SEND-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SEND_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_withdraw_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SEND_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SEND"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-STSUI-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_withdraw`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_USDC_ZERO_ONE_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-STSUI"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-SUIUSDT-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUIUSDT_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_withdraw_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUIUSDT_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUIUSDT"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-SUIBTC-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                        coins_js_1.coinsList["DEEP"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUIBTC_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_withdraw`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                        coins_js_1.coinsList["DEEP"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_SUIBTC_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUIBTC"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-LBTC-SUIBTC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                        coins_js_1.coinsList["DEEP"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_LBTC_SUIBTC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-SUIBTC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_withdraw`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                        coins_js_1.coinsList["DEEP"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_LBTC_SUIBTC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["SUIBTC-LBTC"]),
                        txb.object(maps_js_1.cetusPoolMap["SUIBTC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "BLUEFIN-WAL-USDC") {
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                        coins_js_1.coinsList[maps_js_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object(poolinfo.investorId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_WAL_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${poolinfo.packageId}::alphafi_bluefin_type_1_pool::user_withdraw_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[pool1].type,
                        coins_js_1.coinsList[pool2].type,
                        coins_js_1.coinsList["BLUE"].type,
                        coins_js_1.coinsList["SUI"].type,
                    ],
                    arguments: [
                        txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                        txb.object((0, constants_js_1.getConf)().VERSION),
                        txb.object(receipt[0].objectId),
                        alpha_receipt,
                        txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                        txb.object(poolinfo.poolId),
                        txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object(poolinfo.investorId),
                        txb.pure.u128(xTokens),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_WAL_USDC_POOL),
                        txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                        txb.object(maps_js_1.cetusPoolMap["USDC-WAL"]),
                        txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                        txb.object((0, constants_js_1.getConf)().LST_INFO),
                        txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                        txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
        }
    }
    else {
        throw new Error("No receipt found!");
    }
    return txb;
};
exports.withdrawBluefinType1Txb = withdrawBluefinType1Txb;
const withdrawBluefinType2Txb = async (xTokens, poolName, options) => {
    const address = options.address;
    const txb = new transactions_1.Transaction();
    const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const receipt = await (0, getReceipts_js_1.getReceipts)(poolName, address, true);
    const alphaReceipt = await (0, getReceipts_js_1.getReceipts)("ALPHA", address, true);
    if (receipt.length > 0) {
        let alpha_receipt;
        if (alphaReceipt.length == 0) {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::none`,
                typeArguments: [(0, constants_js_1.getConf)().ALPHA_POOL_RECEIPT],
                arguments: [],
            });
        }
        else {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::some`,
                typeArguments: [alphaReceipt[0].content.type],
                arguments: [txb.object(alphaReceipt[0].objectId)],
            });
        }
        const poolinfo = maps_js_1.poolInfo[poolName];
        if (poolName === "BLUEFIN-ALPHA-USDC") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_type_2_pool::user_withdraw_v2`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    coins_js_1.coinsList["BLUE"].type,
                    coins_js_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, constants_js_1.getConf)().VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.pure.u128(xTokens),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_ALPHA_USDC_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(maps_js_1.cetusPoolMap["ALPHA-USDC"]),
                    txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, constants_js_1.getConf)().LST_INFO),
                    txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-NAVX-VSUI") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_type_2_pool::user_withdraw_v2`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    coins_js_1.coinsList["BLUE"].type,
                    coins_js_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, constants_js_1.getConf)().VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.pure.u128(xTokens),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_NAVX_VSUI_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(maps_js_1.cetusPoolMap["NAVX-VSUI"]),
                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                    txb.object((0, constants_js_1.getConf)().LST_INFO),
                    txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-BLUE-USDC") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_type_2_pool::user_withdraw_v2`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    coins_js_1.coinsList["DEEP"].type,
                    coins_js_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, constants_js_1.getConf)().VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.pure.u128(xTokens),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_USDC_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                    txb.object(maps_js_1.cetusPoolMap["BLUE-USDC"]),
                    txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, constants_js_1.getConf)().LST_INFO),
                    txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-ETH") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_type_2_pool::user_withdraw`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    coins_js_1.coinsList["BLUE"].type,
                    coins_js_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, constants_js_1.getConf)().VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.pure.u128(xTokens),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_ETH_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(maps_js_1.cetusPoolMap["STSUI-ETH"]),
                    txb.object(maps_js_1.cetusPoolMap["ETH-SUI"]),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-WSOL") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_type_2_pool::user_withdraw`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    coins_js_1.coinsList["BLUE"].type,
                    coins_js_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, constants_js_1.getConf)().VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.pure.u128(xTokens),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_WSOL_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(maps_js_1.cetusPoolMap["STSUI-WSOL"]),
                    txb.object(maps_js_1.cetusPoolMap["WSOL-SUI"]),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
    }
    else {
        throw new Error("No receipt found!");
    }
    return txb;
};
exports.withdrawBluefinType2Txb = withdrawBluefinType2Txb;
const withdrawBluefinStsuiTxb = async (xTokens, poolName, options) => {
    const address = options.address;
    const txb = new transactions_1.Transaction();
    const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const receipt = await (0, getReceipts_js_1.getReceipts)(poolName, address, true);
    const alphaReceipt = await (0, getReceipts_js_1.getReceipts)("ALPHA", address, true);
    if (receipt.length > 0) {
        let alpha_receipt;
        if (alphaReceipt.length == 0) {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::none`,
                typeArguments: [(0, constants_js_1.getConf)().ALPHA_POOL_RECEIPT],
                arguments: [],
            });
        }
        else {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::some`,
                typeArguments: [alphaReceipt[0].content.type],
                arguments: [txb.object(alphaReceipt[0].objectId)],
            });
        }
        const poolinfo = maps_js_1.poolInfo[poolName];
        if (poolName === "BLUEFIN-STSUI-USDC") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_stsui_first_pool::user_withdraw`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    coins_js_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, constants_js_1.getConf)().VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.pure.u128(xTokens),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_USDC_ZERO_ONE_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                    txb.object(maps_js_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, constants_js_1.getConf)().LST_INFO),
                    txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-ALPHA-STSUI") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_stsui_second_pool::user_withdraw`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    coins_js_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, constants_js_1.getConf)().VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.pure.u128(xTokens),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_ALPHA_STSUI_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(maps_js_1.cetusPoolMap["ALPHA-SUI"]),
                    txb.object(maps_js_1.bluefinPoolMap["SUI-ALPHA"]),
                    txb.object((0, constants_js_1.getConf)().LST_INFO),
                    txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-WSOL") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_stsui_first_pool::user_withdraw`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    coins_js_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, constants_js_1.getConf)().VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.pure.u128(xTokens),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_WSOL_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(maps_js_1.cetusPoolMap["WSOL-SUI"]),
                    txb.object(maps_js_1.bluefinPoolMap["SUI-WSOL"]),
                    txb.object((0, constants_js_1.getConf)().LST_INFO),
                    txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-ETH") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_stsui_first_pool::user_withdraw`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    coins_js_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, constants_js_1.getConf)().VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.pure.u128(xTokens),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_ETH_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(maps_js_1.cetusPoolMap["ETH-SUI"]),
                    txb.object(maps_js_1.bluefinPoolMap["SUI-ETH"]),
                    txb.object((0, constants_js_1.getConf)().LST_INFO),
                    txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-BUCK") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_stsui_first_pool::user_withdraw`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    coins_js_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, constants_js_1.getConf)().VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.pure.u128(xTokens),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_BUCK_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(maps_js_1.cetusPoolMap["BUCK-SUI"]),
                    txb.object(maps_js_1.bluefinPoolMap["SUI-BUCK"]),
                    txb.object((0, constants_js_1.getConf)().LST_INFO),
                    txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-MUSD") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_stsui_first_pool::user_withdraw`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    coins_js_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, constants_js_1.getConf)().VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.pure.u128(xTokens),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_MUSD_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(maps_js_1.cetusPoolMap["MUSD-SUI"]),
                    txb.object(maps_js_1.bluefinPoolMap["SUI-MUSD"]),
                    txb.object((0, constants_js_1.getConf)().LST_INFO),
                    txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-WAL-STSUI") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_stsui_second_pool::user_withdraw`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    coins_js_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, constants_js_1.getConf)().VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object((0, constants_js_1.getConf)().ALPHA_POOL),
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.pure.u128(xTokens),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_WAL_STSUI_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(maps_js_1.cetusPoolMap["WAL-SUI"]),
                    txb.object(maps_js_1.bluefinPoolMap["SUI-WAL"]),
                    txb.object((0, constants_js_1.getConf)().LST_INFO),
                    txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(true),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
    }
    else {
        throw new Error("No receipt found!");
    }
    return txb;
};
exports.withdrawBluefinStsuiTxb = withdrawBluefinStsuiTxb;
const withdrawBluefinFungibleTxb = async (xTokens, poolName, options) => {
    const address = options.address;
    const txb = new transactions_1.Transaction();
    const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const poolinfo = maps_js_1.poolInfo[poolName];
    const ftCoin = await (0, exports.getCoinObject)(poolinfo.receiptType, address, txb);
    if (ftCoin) {
        const ftCoinsToBurn = txb.splitCoins(ftCoin, [xTokens]);
        if (poolName === "BLUEFIN-FUNGIBLE-STSUI-SUI") {
            txb.moveCall({
                target: `${poolinfo.packageId}::alphafi_bluefin_stsui_sui_ft_pool::user_withdraw`,
                typeArguments: [
                    coins_js_1.coinsList[pool1].type,
                    coins_js_1.coinsList[pool2].type,
                    poolinfo.receiptType,
                    coins_js_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, constants_js_1.getConf)().ALPHA_FUNGIBLE_VERSION),
                    ftCoinsToBurn,
                    txb.object(poolinfo.poolId),
                    txb.object((0, constants_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object(poolinfo.investorId),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_STSUI_SUI_POOL),
                    txb.object((0, constants_js_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object((0, constants_js_1.getConf)().LST_INFO),
                    txb.object((0, constants_js_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, constants_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        txb.transferObjects([ftCoin], address);
    }
    else {
        throw new Error("No ftCoin found!");
    }
    return txb;
};
exports.withdrawBluefinFungibleTxb = withdrawBluefinFungibleTxb;
//# sourceMappingURL=bluefin.js.map